import React, { useEffect, useState } from 'react';
import './EmployeeWeeklyView.css';
import axios from 'axios';
import * as XLSX from 'xlsx'; // ✅ Excel export

const EmployeeWeeklyView = ({ filters }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const params = new URLSearchParams(filters).toString();
    axios
      .get(`https://api-usersreport-insights.haqdarshak.com/api/employee-weekly-view?${params}`)
      .then((res) => {
        const sortedData = [...res.data].sort((a, b) =>
          a.State.localeCompare(b.State)
        );
        setData(sortedData);
      })
      .catch((err) =>
        console.error("Error fetching employee weekly data:", err)
      );
  }, [filters]);

  const formatRange = (start, end) =>
    `${start.toLocaleDateString('en-IN', { day: '2-digit', month: 'long' })} - ${end.toLocaleDateString('en-IN', { day: '2-digit', month: 'long' })}`;

  const getLast7Days = () => {
    const end = new Date();
    end.setDate(end.getDate() - 1);
    const start = new Date();
    start.setDate(start.getDate() - 7);
    return formatRange(start, end);
  };

  const getPrior7Days = () => {
    const end = new Date();
    end.setDate(end.getDate() - 8);
    const start = new Date();
    start.setDate(start.getDate() - 14);
    return formatRange(start, end);
  };

  const last7DaysRange = getLast7Days();
  const prior7DaysRange = getPrior7Days();
  const exportToExcel = () => {
    const exportData = data.map(row => ({
      "State": row.State,
      "Employee Name": row.Opsco_Name,
      "Total HD's": row.Total_hd ?? 0,
      "Active HD's": row.Active_hd ?? 0,
      
      "DI Open (Last 7d)": row.Open_last_7d_DI ?? 0,
      "DI Open (Prior 7d)": row.Open_prior_7d_DI ?? 0,
      "DI Open (% Change)": row.Open_7d_change_pct_DI ?? 0,
      
      "DI DS (Last 7d)": row.ds_last_7d_DI ?? 0,
      "DI DS (Prior 7d)": row.ds_prior_7d_DI ?? 0,
      "DI DS (% Change)": row.ds_7d_change_pct_DI ?? 0,
  
      "DI BR (Last 7d)": row.br_last_7d_DI ?? 0,
      "DI BR (Prior 7d)": row.br_prior_7d_DI ?? 0,
      "DI BR (% Change)": row.br_7d_change_pct_DI ?? 0,
  
      "DFL Open (Last 7d)": row.Open_last_7d_dfl ?? 0,
      "DFL Open (Prior 7d)": row.Open_prior_7d_dfl ?? 0,
      "DFL Open (% Change)": row.Open_7d_change_pct_dfl ?? 0,
  
      "DFL DS (Last 7d)": row.ds_last_7d_dfl ?? 0,
      "DFL DS (Prior 7d)": row.ds_prior_7d_dfl ?? 0,
      "DFL DS (% Change)": row.ds_7d_change_pct_dfl ?? 0,
  
      "DFL BR (Last 7d)": row.br_last_7d_dfl ?? 0,
      "DFL BR (Prior 7d)": row.br_prior_7d_dfl ?? 0,
      "DFL BR (% Change)": row.br_7d_change_pct_dfl ?? 0,
  
      "YC Open (Last 7d)": row.Open_last_7d_yc ?? 0,
      "YC Open (Prior 7d)": row.Open_prior_7d_yc ?? 0,
      "YC Open (% Change)": row.Open_7d_change_pct_yc ?? 0,
  
      "YC DS (Last 7d)": row.ds_last_7d_yc ?? 0,
      "YC DS (Prior 7d)": row.ds_prior_7d_yc ?? 0,
      "YC DS (% Change)": row.ds_7d_change_pct_yc ?? 0,
  
      "YC BR (Last 7d)": row.br_last_7d_yc ?? 0,
      "YC BR (Prior 7d)": row.br_prior_7d_yc ?? 0,
      "YC BR (% Change)": row.br_7d_change_pct_yc ?? 0,
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Weekly View');
    XLSX.writeFile(workbook, 'Employee_Weekly_View.xlsx');
  };
  
  return (
    <div className="achievement-scroll-table-container">
      <h3 className="table-title">Opsco (Fellow/coordinator) weekly performance</h3>
      <button className="export-btn" onClick={exportToExcel}>Export to Excel</button>
      <div className="table-scroll-wrapper">
        <table className="achievement-scroll-table">
          <thead>
            <tr>
              <th rowSpan="3" className="sticky-col">State</th>
              <th rowSpan="3" className="sticky-col-2">Employee name</th>
              <th rowSpan="3">Total HD's</th>
              <th rowSpan="3">Active HD's</th>
              <th colSpan="3">DI (Open)</th>
              <th colSpan="3">DI (DS)</th>
              <th colSpan="3">DI (BR)</th>
              <th colSpan="3">DFL (Open)</th>
              <th colSpan="3">DFL (DS)</th>
              <th colSpan="3">DFL (BR)</th>
              <th colSpan="3">YC (Open)</th>
              <th colSpan="3">YC (DS)</th>
              <th colSpan="3">YC (BR)</th>
            </tr>
            <tr>
              {Array.from({ length: 9 }).map((_, i) => (
                <React.Fragment key={i}>
                  <th>Last 7 days</th>
                  <th>Prior 7 days</th>
                  <th>% Change</th>
                </React.Fragment>
              ))}
            </tr>
            <tr className="date-range-header">
              {Array.from({ length: 9 }).map((_, i) => (
                <React.Fragment key={i}>
                  <th>{last7DaysRange}</th>
                  <th>{prior7DaysRange}</th>
                  <th></th>
                </React.Fragment>
              ))}
            </tr>
          </thead>

          <tbody>
  {data.map((row, idx) => (
    <tr key={idx}>
      <td className="sticky-col">{row.State}</td>
      <td className="sticky-col-2">{row.Opsco_Name}</td>
      <td>{row.Total_hd ?? 0}</td>
      <td>{row.Active_hd ?? 0}</td>

      <td>{row.Open_last_7d_DI ?? 0}</td>
      <td>{row.Open_prior_7d_DI ?? 0}</td>
      <td>{row.Open_7d_change_pct_DI ?? 0}</td>

      <td>{row.ds_last_7d_DI ?? 0}</td>
      <td>{row.ds_prior_7d_DI ?? 0}</td>
      <td>{row.ds_7d_change_pct_DI ?? 0}</td>

      <td>{row.br_last_7d_DI ?? 0}</td>
      <td>{row.br_prior_7d_DI ?? 0}</td>
      <td>{row.br_7d_change_pct_DI ?? 0}</td>

      <td>{row.Open_last_7d_dfl ?? 0}</td>
      <td>{row.Open_prior_7d_dfl ?? 0}</td>
      <td>{row.Open_7d_change_pct_dfl ?? 0}</td>

      <td>{row.ds_last_7d_dfl ?? 0}</td>
      <td>{row.ds_prior_7d_dfl ?? 0}</td>
      <td>{row.ds_7d_change_pct_dfl ?? 0}</td>

      <td>{row.br_last_7d_dfl ?? 0}</td>
      <td>{row.br_prior_7d_dfl ?? 0}</td>
      <td>{row.br_7d_change_pct_dfl ?? 0}</td>

      <td>{row.Open_last_7d_yc ?? 0}</td>
      <td>{row.Open_prior_7d_yc ?? 0}</td>
      <td>{row.Open_7d_change_pct_yc ?? 0}</td>

      <td>{row.ds_last_7d_yc ?? 0}</td>
      <td>{row.ds_prior_7d_yc ?? 0}</td>
      <td>{row.ds_7d_change_pct_yc ?? 0}</td>

      <td>{row.br_last_7d_yc ?? 0}</td>
      <td>{row.br_prior_7d_yc ?? 0}</td>
      <td>{row.br_7d_change_pct_yc ?? 0}</td>
    </tr>
  ))}
</tbody>

        </table>
      </div>
    </div>
  );
};

export default EmployeeWeeklyView;
